import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { AuthProvider, useAuth } from './admin/AuthContext';
import { SiteContentProvider } from './contexts/SiteContentContext';
import { AdminLayout } from './admin/AdminLayout';
import { AdminLogin } from './admin/AdminLogin';
import { AdminDashboard } from './admin/AdminDashboard';
import { AdminSessions } from './admin/AdminSessions';
import { AdminBookings } from './admin/AdminBookings';
import { AdminLocations } from './admin/AdminLocations';
import { AdminClassTypes } from './admin/AdminClassTypes';
import { AdminAvailability } from './admin/AdminAvailability';
import { AvailabilityProvider } from './contexts/AvailabilityContext';
import { AdminDataProvider } from './contexts/AdminDataContext';
const ProtectedRoute = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const {
    isAuthenticated
  } = useAuth();
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace data-id="element-641" />;
  }
  return <>{children}</>;
};
export function App() {
  return <AuthProvider data-id="element-642">
      <SiteContentProvider data-id="element-643">
        <AvailabilityProvider data-id="element-644">
          <AdminDataProvider data-id="element-645">
            <BrowserRouter data-id="element-646">
              <Routes data-id="element-647">
                {/* Public Route */}
                <Route path="/" element={<LandingPage data-id="element-649" />} data-id="element-648" />

                {/* Admin Login Route */}
                <Route path="/admin/login" element={<AdminLogin data-id="element-651" />} data-id="element-650" />

                {/* Protected Admin Routes */}
                <Route path="/admin" element={<ProtectedRoute data-id="element-653">
                      <AdminLayout data-id="element-654" />
                    </ProtectedRoute>} data-id="element-652">
                  <Route index element={<AdminDashboard data-id="element-656" />} data-id="element-655" />
                  <Route path="availability" element={<AdminAvailability data-id="element-658" />} data-id="element-657" />
                  <Route path="sessions" element={<AdminSessions data-id="element-660" />} data-id="element-659" />
                  <Route path="bookings" element={<AdminBookings data-id="element-662" />} data-id="element-661" />
                  <Route path="locations" element={<AdminLocations data-id="element-664" />} data-id="element-663" />
                  <Route path="class-types" element={<AdminClassTypes data-id="element-666" />} data-id="element-665" />
                </Route>
              </Routes>
            </BrowserRouter>
          </AdminDataProvider>
        </AvailabilityProvider>
      </SiteContentProvider>
    </AuthProvider>;
}